module.exports = __webpack_public_path__ + "static/media/italic.afbd719d.svg";